import redirectInterceptor from "@/interceptors/redirect_interceptor";
import { ALARMS_ENDPOINT } from "@/domain/data_overview/data";


export const getVesselAlarms = async (vesselName) => {
  const response = await redirectInterceptor.get(ALARMS_ENDPOINT, {
    params: { vessel: vesselName },
    headers: {
      Authorization: localStorage.getItem("quad_token"),
    },
  });

  return response.data;
};
